import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {StyleSheet} from 'react-native';
import {Text, View, Dimensions} from 'react-native';
import {TouchableOpacity} from 'react-native-gesture-handler';
import HomeHeader from '../../components/HomeHeader';
import {BsChevronRight} from 'react-icons/bs';

const HEIGHT = Dimensions.get('window').height;

export default function TermsConditionsScreen(props) {
  return (
    <View
      style={{
        height: HEIGHT,
      }}>
      <HomeHeader navigation={props.navigation} />
      <Text style={styles.header}>Terms {'&'} conditions</Text>
      <Container>
        <Row>
          <Col md={3}></Col>
          <Col md={6}>
            <View>
              <TouchableOpacity style={styles.termsAndConditions}>
                <Text style={styles.question}>Ulka Offers</Text>
                <BsChevronRight color={'lightgray'} size={20} />
              </TouchableOpacity>
              <TouchableOpacity style={styles.termsAndConditions}>
                <Text style={styles.question}>Ulka Conditions</Text>
                <BsChevronRight color={'lightgray'} size={20} />
              </TouchableOpacity>
            </View>
          </Col>
          <Col md={3}></Col>
        </Row>
      </Container>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    color: 'lightgray',
    alignSelf: 'center',
    marginVertical: 30,
    fontWeight: 'bold',
    fontSize: 20,
  },
  question: {
    color: 'lightgray',
    fontSize: 17,
  },
  termsAndConditions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderColor: 'gray',
    paddingBottom: 10,
    marginVertical: 10,
  },
});
